<strong>OFFICE(S)</strong>
@if (!officesRefreshing) {
  <div>
    @if (providerOffices) {
      <div class="row">
        @for (providerOffice of providerOffices; track providerOffice) {
          <div
            class="office col-auto"
            [ngClass]="{ 'pre-scrollable': scrollable, 'border': scrollable }">
            <app-office
              [office]="providerOffice.office"
              [providerOffice]="providerOffice" />
          </div>
        }
      </div>
    }
    @if (providerOffices.length === 0) {
      <div class="fst-italic">
        No prescriber offices in supplemental data
      </div>
    }
  </div>
}
